import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CebeContratoViewModel } from '../models/centros/cebe-contract.model';
import { ApiEnum, HttpDataService } from './http-data.service';


@Injectable({
    providedIn: 'root'
})

export class CebesContractService {
    
    constructor(private readonly httpDataService: HttpDataService) {
    }

    getContratoByCebe(id: number, actividadId: number, tipoProyectoId: number): Observable<CebeContratoViewModel> {
        return this.httpDataService.get$<CebeContratoViewModel>(ApiEnum.API_ROOT, `${environment.endpoint.cebeContratos.getContratoByCebe  }/${  id  }/${  actividadId  }/${  tipoProyectoId}`)
        .pipe(
            map((contract) => {
                return contract;
            }),
            retry(3),
            catchError(this.httpDataService.handleError<CebeContratoViewModel>('getContratoByCebe'))
        );
    }

    updateContract(contract: CebeContratoViewModel): Observable<CebeContratoViewModel> {
        return this.httpDataService.put$<CebeContratoViewModel>(ApiEnum.API_ROOT, environment.endpoint.cebeContratos.updateContrato, contract)
        .pipe(
            map((contract) => {
                return contract;
            }),
            retry(3),
            catchError(this.httpDataService.handleError<CebeContratoViewModel>('updateContract'))
        );
    }
}